import Home from '@app/components/students/Home'
import InappropriateGrade from '@app/components/students/InappropriateGrade'
import ComingSoon from '@app/components/students/ComingSoon'
import MainIntro from '@app/components/students/Start/MainIntro'
import Start from '@app/containers/students/Start'
import PreparatoryTasks from '@app/components/students/PreparatoryTasks'
import TrialTasks from '@app/components/students/TrialTasks'
import Task from '@app/containers/students/Task'
import Solution from '@app/components/students/Solution'
import Answer from '@app/components/students/Answer'
import MainTasks from '@app/components/students/MainTasks'
import Results from '@app/components/students/Results'
import Rewarding from '@app/components/students/Rewarding'
import StudentPlayerLayout from '@app/components/Template/students/StudentPlayerLayout.jsx'

export default {
  Home: {
    component: Home,
    exact: true,
    path: '/students/home'
  },

  InappropriateGrade: {
    component: InappropriateGrade,
    exact: true,
    path: '/students/inappropriate_grade'
  },

  ComingSoon: {
    component: ComingSoon,
    exact: true,
    path: '/students/coming_soon'
  },

  PreparatoryTasks: {
    component: PreparatoryTasks,
    exact: true,
    path: '/students/tasks/preparatory'
  },

  TrialTasks: {
    component: TrialTasks,
    exact: true,
    path: '/students/tasks/trial'
  },

  Task: {
    component: Task,
    exact: true,
    path: '/students/tours/:tour/tasks/:id',
    layout: StudentPlayerLayout
  },

  Answer: {
    component: Answer,
    exact: true,
    path: '/students/tours/:tour/tasks/:id/answer'
  },

  MainIntro: {
    component: MainIntro,
    exact: true,
    path: '/students/tours/main/intro'
  },

  Start: {
    component: Start,
    exact: true,
    path: '/students/tours/:tour/start'
  },

  MainTasks: {
    component: MainTasks,
    exact: true,
    path: '/students/tasks/main'
  },

  Results: {
    component: Results,
    exact: true,
    path: '/students/results/tasks'
  },

  Rewarding: {
    component: Rewarding,
    exact: true,
    path: '/students/results/rewarding'
  },

  Solution: {
    component: Solution,
    exact: true,
    path: '/students/results/tasks/:id'
  }
}
